import { render } from "./SteunOns.vue?vue&type=template&id=04630e53&scoped=true"
import script from "./SteunOns.vue?vue&type=script&lang=js"
export * from "./SteunOns.vue?vue&type=script&lang=js"

import "./SteunOns.vue?vue&type=style&index=0&id=04630e53&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04630e53"]])

export default __exports__